import { useEffect } from "react";

/** Locks page scroll behind a fixed-position overlay (custom modals, lightboxes,
 * drawers) while `locked` is true, restoring the previous value on unlock/unmount.
 * Locks both <html> and <body> — in standards-mode browsers (most mobile
 * browsers included) the document's actual scrolling box is documentElement,
 * not body, so body-only used to silently fail to stop background scroll. */
export default function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    const { overflow: bodyOverflow } = document.body.style;
    const { overflow: htmlOverflow } = document.documentElement.style;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = htmlOverflow;
    };
  }, [locked]);
}
